import { LinkStyled } from '@components/v2/link/LinkStyled';
import styled from 'styled-components';

export const LinkStyledAP = styled(LinkStyled)``;
